import * as React from 'react';
import { fetchApi, makeResetCache, notifyError, notifyResponse, RecordPicker } from 'gossamer-front-end';
import {
  AdminInstitutionGroupEventAddRequest,
  Event,
  InstitutionGroupEvent,
  InstitutionGroupEventView,
} from 'cb-model';
import { InputGroup } from 'react-bootstrap';
import { FieldType, getFilter } from 'gossamer-unified';
import { useDispatch } from 'react-redux';

export interface AddEventToGroupButtonProps {
  institutionGroupId: number;
  institutionId: number;
}

export const AddEventToGroupButton: React.FC<AddEventToGroupButtonProps> = (props): React.JSX.Element => {
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const isProcessing = React.useRef(false);

  const handleAdd = async (eventId: string) => {
    if (isProcessing.current) {
      return;
    }
    try {
      isProcessing.current = true;
      const resp = await fetchApi('POST', `/main/institution-group-event-add`, {
        eventId: parseInt(eventId),
        institutionGroupId: props.institutionGroupId,
      } as AdminInstitutionGroupEventAddRequest);
      resetCache(Event.id);
      resetCache(InstitutionGroupEvent.id);
      resetCache(InstitutionGroupEventView.id);
      notifyResponse(resp);
    } catch (e) {
      notifyError(e, 'An error occurred while adding the event to the group');
    }
    isProcessing.current = false;
  };
  return (
    <InputGroup>
      <InputGroup.Text>Add an existing Event to this Group</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={handleAdd}
        value={null}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'Event',
          refEntity: Event,
        }}
        queryOptions={{
          where: {
            and: [getFilter('title', 'ct', ''), getFilter('institution_id', 'eq', props.institutionId, 'hidden')],
          },
          order: [['title', 'ASC']],
        }}
      />
    </InputGroup>
  );
};
